export default __webpack_public_path__ + "static/cafe_36056-9b0059e7212bb5e0c83d952e95382a7d.png";